export const SET_SCAN_CLAIM = 'SET_SCAN_CLAIM';
